module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lCVmS"))).then(() => module.bundle.root('dsisd'));